import { apiClient } from '../api-client';
import type { ApiResponse } from '@/types/api';
import type { SortId, CreateSortIdRequest, UpdateSortIdRequest } from '@/types/inventory';

export const sortIdsApi = {
  getAll: async (type: 1 | 2, isActive?: boolean) => {
    const params: Record<string, unknown> = { type };
    if (isActive !== undefined) params.isActive = isActive;
    const response = await apiClient.get<ApiResponse<SortId[]>>('/sortids', { params });
    return response.data.data;
  },

  getById: async (id: number) => {
    const response = await apiClient.get<ApiResponse<SortId>>(`/sortids/${id}`);
    return response.data.data;
  },

  create: async (data: CreateSortIdRequest) => {
    const response = await apiClient.post<ApiResponse<SortId>>('/sortids', data);
    return response.data.data;
  },

  update: async (id: number, data: UpdateSortIdRequest) => {
    const response = await apiClient.put<ApiResponse<SortId>>(`/sortids/${id}`, data);
    return response.data.data;
  },

  bulkUpdateActive: async (ids: number[], isActive: boolean) => {
    const response = await apiClient.put<ApiResponse<null>>('/sortids/bulk-update', { ids, isActive });
    return response.data;
  },

  delete: async (id: number) => {
    await apiClient.delete(`/sortids/${id}`);
  },

  restore: async (id: number) => {
    await apiClient.post(`/sortids/${id}/restore`);
  },
};
